import '/vendor/jquery-browser-mobile/jquery.browser.mobile.js';
import '/vendor/common/common.js';
import '/vendor/owl.carousel/owl.carousel.js';
import '/vendor/jquery.lazyload/jquery.lazyload.js';

window.theme = {};

// Dynamic loader for Magnific Popup
window.__magnificLoadPromise = window.__magnificLoadPromise || null;
window.loadMagnificPopup = function() {
    var $ = window.jQuery || window.$;
    if ($ && $.fn && $.fn.magnificPopup) {
        return Promise.resolve();
    }
    if (window.__magnificLoadPromise) {
        return window.__magnificLoadPromise;
    }
    window.__magnificLoadPromise = import('/vendor/magnific-popup/jquery.magnific-popup.js').then(function() {
        return;
    }).catch(function(err){
        window.__magnificLoadPromise = null;
        throw err;
    });
    return window.__magnificLoadPromise;
};

// Theme Common Functions
window.theme.fn = {

    getOptions: function(opts) {

        if (typeof(opts) == 'object') {

            return opts;

        } else if (typeof(opts) == 'string') {

            try {
                return JSON.parse(opts.replace(/'/g,'"').replace(';',''));
            } catch(e) {
                return {};
            }

        } else {

            return {};

        }

    }

};


// Bootstrap Toggle
(function($) {

    'use strict';

    var $window = $( window );

    var toggleClass = function( $el ) {
        if ( !!$el.data('toggleClassBinded') ) {
            return false;
        }

        var $target,
            className,
            eventName;

        $target = $( $el.attr('data-target') );
        className = $el.attr('data-toggle-class');
        eventName = $el.attr('data-fire-event');


        $el.on('click.toggleClass', function(e) {
            e.preventDefault();
            $target.toggleClass( className );

            var hasClass = $target.hasClass( className );

            if ( !!eventName ) {
                $window.trigger( eventName, {
                    added: hasClass,
                    removed: !hasClass
                });
            }
        });

        $el.data('toggleClassBinded', true);

        return true;
    };

    $(function() {
        $('[data-toggle-class][data-target]').each(function() {
            toggleClass( $(this) );
        });
    });

}).apply(this, [jQuery]);

// Cards
(function($) {

    $(function() {
        $('.card')
            .on( 'card:toggle', function() {
                var $this,
                    direction;

                $this = $(this);
                direction = $this.hasClass( 'card-collapsed' ) ? 'Down' : 'Up';

                $this.find('.card-body, .card-footer')[ 'slide' + direction ]( 200, function() {
                    $this[ (direction === 'Up' ? 'add' : 'remove') + 'Class' ]( 'card-collapsed' )
                });
            })
            .on( 'card:dismiss', function() {
                var $this = $(this);

                if ( !!( $this.parent('div').attr('class') || '' ).match( /col-(xs|sm|md|lg)/g ) && $this.siblings().length === 0 ) {
                    $row = $this.closest('.row');
                    $this.parent('div').remove();
                    if ( $row.children().length === 0 ) {
                        $row.remove();
                    }
                } else {
                    $this.remove();
                }
            })
            .on( 'click', '[data-card-toggle]', function( e ) {
                e.preventDefault();
                $(this).closest('.card').trigger( 'card:toggle' );
            })
            .on( 'click', '[data-card-dismiss]', function( e ) {
                e.preventDefault();
                $(this).closest('.card').trigger( 'card:dismiss' );
            })
            /* Deprecated */
            .on( 'click', '.card-actions a.fa-caret-up', function( e ) {
                e.preventDefault();
                var $this = $( this );

                $this
                    .removeClass( 'fa-caret-up' )
                    .addClass( 'fa-caret-down' );

                $this.closest('.card').trigger( 'card:toggle' );
            })
            .on( 'click', '.card-actions a.fa-caret-down', function( e ) {
                e.preventDefault();
                var $this = $( this );

                $this
                    .removeClass( 'fa-caret-down' )
                    .addClass( 'fa-caret-up' );

                $this.closest('.card').trigger( 'card:toggle' );
            })
            .on( 'click', '.card-actions a.fa-times', function( e ) {
                e.preventDefault();
                var $this = $( this );

                $this.closest('.card').trigger( 'card:dismiss' );
            });
    });

})(jQuery);

// Carousel
(function(theme, $) {

    theme = theme || {};

    var initialized = false;
    var instanceName = '__carousel';

    var PluginCarousel = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginCarousel.defaults = {
        navText: [],
        a11yPrevLabel: 'Anterior',
        a11yNextLabel: 'Siguiente'
    };

    PluginCarousel.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, PluginCarousel.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        build: function() {
            var self = this;
            var $wrapper = this.options.wrapper;
            function applyA11y() {
                var prevLabel = self.options.a11yPrevLabel || 'Anterior';
                var nextLabel = self.options.a11yNextLabel || 'Siguiente';
                $wrapper.find('.owl-nav button.owl-prev')
                    .attr('aria-label', prevLabel)
                    .attr('title', prevLabel)
                    .attr('role', 'button');
                $wrapper.find('.owl-nav button.owl-next')
                    .attr('aria-label', nextLabel)
                    .attr('title', nextLabel)
                    .attr('role', 'button');
            }
            $wrapper.on('initialized.owl.carousel refreshed.owl.carousel', function(){
                applyA11y();
            });
            this.options.wrapper.owlCarousel(this.options).addClass("owl-carousel-init");
            // Apply immediately in case nav exists right away
            applyA11y();

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginCarousel: PluginCarousel
    });

    // jquery plugin
    $.fn.themePluginCarousel = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginCarousel($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);



// Header Menu Nav
(function(theme, $) {

    'use strict';

    theme = theme || {};

    var initialized = false;

    $.extend(theme, {

        Nav: {

            defaults: {
                wrapper: $('#mainNav'),
                scrollDelay: 600,
                scrollAnimation: 'easeOutQuad'
            },

            initialize: function($wrapper, opts) {
                if (initialized) {
                    return this;
                }

                initialized = true;
                this.$wrapper = ($wrapper || this.defaults.wrapper);

                this
                    .setOptions(opts)
                    .build()
                    .events();

                return this;
            },

            setOptions: function(opts) {
                // this.options = $.extend(true, {}, this.defaults, opts, theme.fn.getOptions(this.$wrapper.data('plugin-options')));

                return this;
            },

            build: function() {
                var self = this,
                    $html = $('html'),
                    $header = $('.header'),
                    thumbInfoPreview;

                // Add Arrows
                $header.find('.dropdown-toggle:not(.notification-icon), .dropdown-submenu > a').append($('<i />').addClass('fas fa-caret-down'));

                // Preview Thumbs
                self.$wrapper.find('a[data-thumb-preview]').each(function() {
                    thumbInfoPreview = $('<span />').addClass('thumb-info thumb-info-preview')
                        .append($('<span />').addClass('thumb-info-wrapper')
                            .append($('<span />').addClass('thumb-info-image').css('background-image', 'url(' + $(this).data('thumb-preview') + ')')
                            )
                        );

                    $(this).append(thumbInfoPreview);
                });

                // Side Header Right (Reverse Dropdown)
                if($html.hasClass('side-header-right')) {
                    $header.find('.dropdown').addClass('dropdown-reverse');
                }

                return this;
            },

            events: function() {
                var self = this,
                    $header = $('.header'),
                    $window = $(window);

                $header.find('a[href="#"]').on('click', function(e) {
                    e.preventDefault();
                });

                // Mobile Arrows
                $header.find('.dropdown-toggle[href="#"], .dropdown-submenu a[href="#"], .dropdown-toggle[href!="#"] .fa-caret-down, .dropdown-submenu a[href!="#"] .fa-caret-down').on('click', function(e) {
                    e.preventDefault();
                    if ($window.width() < 992) {
                        $(this).closest('li').toggleClass('showed');
                    }
                });

                // Touch Devices with normal resolutions
                if('ontouchstart' in document.documentElement) {
                    $header.find('.dropdown-toggle:not([href="#"]), .dropdown-submenu > a:not([href="#"])')
                        .on('touchstart click', function(e) {
                            if($window.width() > 991) {

                                e.stopPropagation();
                                e.preventDefault();

                                if(e.handled !== true) {

                                    var li = $(this).closest('li');

                                    if(li.hasClass('tapped')) {
                                        location.href = $(this).attr('href');
                                    }

                                    li.addClass('tapped');

                                    e.handled = true;
                                } else {
                                    return false;
                                }

                                return false;

                            }
                        })
                        .on('blur', function(e) {
                            $(this).closest('li').removeClass('tapped');
                        });

                }

                // Collapse Nav
                $header.find('[data-collapse-nav]').on('click', function(e) {
                    $(this).parents('.collapse').removeClass('in');
                });

                // Anchors Position
                $('[data-hash]').each(function() {

                    var target = $(this).attr('href'),
                        offset = ($(this).is("[data-hash-offset]") ? $(this).data('hash-offset') : 0);

                    if($(target).get(0)) {
                        $(this).on('click', function(e) {
                            e.preventDefault();

                            // Close Collapse if Opened
                            $(this).parents('.collapse.in').removeClass('in');

                            self.scrollToTarget(target, offset);

                            return;
                        });
                    }

                });

                return this;
            },

            scrollToTarget: function(target, offset) {
                var self = this;

                $('body').addClass('scrolling');

                $('html, body').animate({
                    scrollTop: $(target).offset().top - offset
                }, self.options.scrollDelay, self.options.scrollAnimation, function() {
                    $('body').removeClass('scrolling');
                });

                return this;

            }

        }

    });

}).apply(this, [window.theme, jQuery]);



// iosSwitcher
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__IOS7Switch';

    var PluginIOS7Switch = function($el) {
        return this.initialize($el);
    };

    PluginIOS7Switch.prototype = {
        initialize: function($el) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        build: function() {
            var switcher = new Switch( this.$el.get(0) );

            $( switcher.el ).on( 'click', function( e ) {
                e.preventDefault();
                switcher.toggle();
            });

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginIOS7Switch: PluginIOS7Switch
    });

    // jquery plugin
    $.fn.themePluginIOS7Switch = function(opts) {
        return this.each(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginIOS7Switch($this);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);

// Form to Object
(function($) {

    'use strict';

    $.fn.formToObject = function() {
        var arrayData,
            objectData;

        arrayData	= this.serializeArray();
        objectData	= {};

        $.each( arrayData, function() {
            var value;

            if (this.value != null) {
                value = this.value;
            } else {
                value = '';
            }

            if (objectData[this.name] != null) {
                if (!objectData[this.name].push) {
                    objectData[this.name] = [objectData[this.name]];
                }

                objectData[this.name].push(value);
            } else {
                objectData[this.name] = value;
            }
        });

        return objectData;
    };

})(jQuery);

// Lazy Load
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__lazyload';

    var PluginLazyLoad = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginLazyLoad.defaults = {
        effect: 'show',
        appearEffect: '',
        imgFluid: true,
        appear: function(elements_left, settings) {

        },
        load: function(elements_left, settings) {
            $(this).addClass($.trim('lazy-load-loaded ' + settings.appearEffect)).css({
                'animation-duration': '1s'
            });
        }
    };

    PluginLazyLoad.prototype = {
        initialize: function($el, opts) {
            if ($el.data(instanceName)) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build()
                .events();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, PluginLazyLoad.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        build: function() {
            var self = this;

            // Add height on images based on <img> height attribute. This prevent some issues like isotope position, etc...
            if (self.options.wrapper.attr('height')) {
                self.options.wrapper.height(self.options.wrapper.attr('height'));
            }

            // Prefer native lazy-loading when available to avoid scroll-based layout thrashing
            if (self.options.wrapper.is('img')) {
                var $img = self.options.wrapper;
                var originalSrc = $img.attr('data-original') || $img.attr('data-src');

                if ('loading' in HTMLImageElement.prototype) {
                    if (originalSrc) {
                        $img.attr('src', originalSrc);
                    }
                    $img.attr('loading', 'lazy').attr('decoding', 'async');
                    // Apply loaded effect class similar to plugin callback
                    if (PluginLazyLoad && PluginLazyLoad.defaults && PluginLazyLoad.defaults.load) {
                        PluginLazyLoad.defaults.load.call($img[0], 0, self.options);
                    } else {
                        $img.addClass($.trim('lazy-load-loaded ' + (self.options.appearEffect || ''))).css({'animation-duration':'1s'});
                    }
                    return this;
                }

                // Use IntersectionObserver if supported (no scroll listener cost)
                if ('IntersectionObserver' in window) {
                    var io = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                if (originalSrc && !$img.attr('src')) {
                                    $img.attr('src', originalSrc);
                                }
                                $img.attr('decoding', 'async');
                                // mimic plugin loaded callback
                                if (PluginLazyLoad && PluginLazyLoad.defaults && PluginLazyLoad.defaults.load) {
                                    PluginLazyLoad.defaults.load.call($img[0], 0, self.options);
                                } else {
                                    $img.addClass($.trim('lazy-load-loaded ' + (self.options.appearEffect || ''))).css({'animation-duration':'1s'});
                                }
                                io.unobserve(entry.target);
                            }
                        });
                    }, { rootMargin: (self.options.threshold ? self.options.threshold + 'px' : '0px') });
                    io.observe($img[0]);
                    return this;
                }
            }

            // Fallback to jQuery LazyLoad plugin when needed
            if (!($.isFunction($.fn.lazyload))) {
                return this;
            }
            self.options.wrapper.lazyload(this.options);

            return this;
        },

        events: function() {
            var self = this;

            if( self.options.imgFluid && self.options.wrapper.is('img') ) {
                self.options.wrapper.on('appear', function(){
                    setTimeout(function(){
                        self.options.wrapper.addClass('img-fluid');
                    }, 500);

                    // // Sort Refresh
                    // if( self.options.wrapper.closest('.sort-destination').get(0) ) {
                    // 	self.options.wrapper.closest('.sort-destination').isotope('layout');
                    // }
                });
            }

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginLazyLoad: PluginLazyLoad
    });

    // jquery plugin
    $.fn.themePluginLazyLoad = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginLazyLoad($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);

// Lightbox
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__lightbox';

    var PluginLightbox = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginLightbox.defaults = {
        tClose: 'Close (Esc)', // Alt text on close button
        tLoading: 'Loading...', // Text that is displayed during loading. Can contain %curr% and %total% keys
        gallery: {
            tPrev: 'Previous (Left arrow key)', // Alt text on left arrow
            tNext: 'Next (Right arrow key)', // Alt text on right arrow
            tCounter: '%curr% of %total%' // Markup for "1 of 7" counter
        },
        image: {
            tError: '<a href="%url%">The image</a> could not be loaded.' // Error message when image could not be loaded
        },
        ajax: {
            tError: '<a href="%url%">The content</a> could not be loaded.' // Error message when ajax request failed
        }
    };

    PluginLightbox.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, PluginLightbox.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        build: function() {
            if (typeof window.loadMagnificPopup === 'function') {
                window.loadMagnificPopup().then(() => {
                    this.options.wrapper.magnificPopup(this.options);
                });
            } else if ($ && $.fn && $.fn.magnificPopup) {
                this.options.wrapper.magnificPopup(this.options);
            }

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginLightbox: PluginLightbox
    });

    // jquery plugin
    $.fn.themePluginLightbox = function(opts) {
        return this.each(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginLightbox($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);

// Loading Overlay
(function(theme, $) {

    'use strict';

    theme = theme || {};

    var loadingOverlayTemplate = [
        '<div class="loading-overlay">',
        '<div class="bounce-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
        '</div>'
    ].join('');

    var LoadingOverlay = function( $wrapper, options ) {
        return this.initialize( $wrapper, options );
    };

    LoadingOverlay.prototype = {

        options: {
            css: {}
        },

        initialize: function( $wrapper, options ) {
            this.$wrapper = $wrapper;

            this
                .setVars()
                .setOptions( options )
                .build()
                .events();

            this.$wrapper.data( 'loadingOverlay', this );
        },

        setVars: function() {
            this.$overlay = this.$wrapper.find('.loading-overlay');

            return this;
        },

        setOptions: function( options ) {
            if ( !this.$overlay.get(0) ) {
                this.matchProperties();
            }
            this.options     = $.extend( true, {}, this.options, options );
            this.loaderClass = this.getLoaderClass( this.options.css.backgroundColor );

            return this;
        },

        build: function() {
            if ( !this.$overlay.closest(document.documentElement).get(0) ) {
                if ( !this.$cachedOverlay ) {
                    this.$overlay = $( loadingOverlayTemplate ).clone();

                    if ( this.options.css ) {
                        this.$overlay.css( this.options.css );
                        this.$overlay.find( '.loader' ).addClass( this.loaderClass );
                    }
                } else {
                    this.$overlay = this.$cachedOverlay.clone();
                }

                this.$wrapper.append( this.$overlay );
            }

            if ( !this.$cachedOverlay ) {
                this.$cachedOverlay = this.$overlay.clone();
            }

            return this;
        },

        events: function() {
            var _self = this;

            if ( this.options.startShowing ) {
                _self.show();
            }

            if ( this.$wrapper.is('body') || this.options.hideOnWindowLoad ) {
                $( window ).on( 'load error', function() {
                    _self.hide();
                });
            }

            if ( this.options.listenOn ) {
                $( this.options.listenOn )
                    .on( 'loading-overlay:show beforeSend.ic', function( e ) {
                        e.stopPropagation();
                        _self.show();
                    })
                    .on( 'loading-overlay:hide complete.ic', function( e ) {
                        e.stopPropagation();
                        _self.hide();
                    });
            }

            this.$wrapper
                .on( 'loading-overlay:show beforeSend.ic', function( e ) {
                    if ( e.target === _self.$wrapper.get(0) ) {
                        e.stopPropagation();
                        _self.show();
                        return true;
                    }
                    return false;
                })
                .on( 'loading-overlay:hide complete.ic', function( e ) {
                    if ( e.target === _self.$wrapper.get(0) ) {
                        e.stopPropagation();
                        _self.hide();
                        return true;
                    }
                    return false;
                });

            return this;
        },

        show: function() {
            this.build();

            this.position = this.$wrapper.css( 'position' ).toLowerCase();
            if ( this.position != 'relative' || this.position != 'absolute' || this.position != 'fixed' ) {
                this.$wrapper.css({
                    position: 'relative'
                });
            }
            this.$wrapper.addClass( 'loading-overlay-showing' );
        },

        hide: function() {
            var _self = this;

            setTimeout(function() {
                _self.$wrapper.removeClass( 'loading-overlay-showing' );

                if ( this.position != 'relative' || this.position != 'absolute' || this.position != 'fixed' ) {
                    _self.$wrapper.css({ position: '' });
                }

                $(window).trigger('loading.overlay.ready');
            }, 500);
        },

        matchProperties: function() {
            var i,
                l,
                properties;

            properties = [
                'backgroundColor',
                'borderRadius'
            ];

            l = properties.length;

            for( i = 0; i < l; i++ ) {
                var obj = {};
                obj[ properties[ i ] ] = this.$wrapper.css( properties[ i ] );

                $.extend( this.options.css, obj );
            }
        },

        getLoaderClass: function( backgroundColor ) {
            if ( !backgroundColor || backgroundColor === 'transparent' || backgroundColor === 'inherit' ) {
                return 'black';
            }

            var hexColor,
                r,
                g,
                b,
                yiq;

            var colorToHex = function( color ){
                var hex,
                    rgb;

                if( color.indexOf('#') >- 1 ){
                    hex = color.replace('#', '');
                } else {
                    rgb = color.match(/\d+/g);
                    hex = ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2);
                }

                if ( hex.length === 3 ) {
                    hex = hex + hex;
                }

                return hex;
            };

            hexColor = colorToHex( backgroundColor );

            r = parseInt( hexColor.substr( 0, 2), 16 );
            g = parseInt( hexColor.substr( 2, 2), 16 );
            b = parseInt( hexColor.substr( 4, 2), 16 );
            yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

            return ( yiq >= 128 ) ? 'black' : 'white';
        }

    };

    // expose to scope
    $.extend(theme, {
        LoadingOverlay: LoadingOverlay
    });

    // expose as a jquery plugin
    $.fn.loadingOverlay = function( opts ) {
        return this.each(function() {
            var $this = $( this );

            var loadingOverlay = $this.data( 'loadingOverlay' );
            if ( loadingOverlay ) {
                return loadingOverlay;
            } else {
                var options = opts || $this.data( 'loading-overlay-options' ) || {};
                return new LoadingOverlay( $this, options );
            }
        });
    }

    // auto init
    $('[data-loading-overlay]').loadingOverlay();

}).apply(this, [window.theme, jQuery]);



// Notifications - Config
(function($) {

    'use strict';

    // use font awesome icons if available
    if ( typeof PNotify != 'undefined' ) {
        PNotify.prototype.options.styling = "fontawesome";

        $.extend(true, PNotify.prototype.options, {
            shadow: false,
            stack: {
                spacing1: 15,
                spacing2: 15
            }
        });

        $.extend(PNotify.styling.fontawesome, {
            // classes
            container: "notification",
            notice: "notification-warning",
            info: "notification-info",
            success: "notification-success",
            error: "notification-danger",

            // icons
            notice_icon: "fas fa-exclamation",
            info_icon: "fas fa-info",
            success_icon: "fas fa-check",
            error_icon: "fas fa-times"
        });
    }

}).apply(this, [jQuery]);

// Portlets
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__portlet',
        storageOrderKey = '__portletOrder',
        storageStateKey = '__portletState';

    var PluginPortlet = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginPortlet.defaults = {
        connectWith: '[data-plugin-portlet]',
        items: '[data-portlet-item]',
        helper: 'clone',
        sort: function(event, ui) {
            var $target = $(event.target);
            if (!/html|body/i.test($target.offsetParent()[0].tagName)) {
                var top = event.pageY - $target.offsetParent().offset().top - (ui.helper.outerHeight(true) / 2);
                ui.helper.css({'top' : top + 'px'});
            }
        }
    };

    PluginPortlet.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            var _self = this;

            this.options = $.extend(true, {}, PluginPortlet.defaults, opts, {
                wrapper: this.$el,
                update: _self.onUpdate,
                create: _self.onLoad
            });

            return this;
        },

        onUpdate: function(event, ui) {
            var key = storageOrderKey,
                data = store.get(key),
                $this = $(this),
                porletId = $this.prop('id');

            if (!data) {
                data = {};
            }

            if (!!porletId) {
                data[porletId] = $this.sortable('toArray');
                store.set(key, data);
            }
        },

        onLoad: function(event, ui) {
            var key = storageOrderKey,
                data = store.get(key),
                $this = $(this),
                porletId = $this.prop('id'),
                portlet = $('#' + porletId);

            if (!!data) {
                var cards = data[porletId];

                if (!!cards) {
                    $.each(cards, function(index, panelId) {
                        $('#' + panelId).appendTo(portlet);
                    });
                }
            }
        },

        saveState: function( panel ) {
            var key = storageStateKey,
                data = store.get(key),
                panelId = panel.prop('id');

            if (!data) {
                data = {};
            }

            if (!panelId) {
                return this;
            }

            var collapse = panel.find('.card-actions').children('a.fa-caret-up, a.fa-caret-down'),
                isCollapsed = !!collapse.hasClass('fa-caret-up'),
                isRemoved = !panel.closest('body').get(0);

            if (isRemoved) {
                data[panelId] = 'removed';
            } else if (isCollapsed) {
                data[panelId] = 'collapsed';
            } else {
                delete data[panelId];
            }

            store.set(key, data);
            return this;
        },

        loadState: function() {
            var key = storageStateKey,
                data = store.get(key);

            if (!!data) {
                $.each(data, function(panelId, state) {
                    var panel = $('#' + panelId);
                    if (!panel.data('portlet-state-loaded')) {
                        if (state == 'collapsed') {
                            panel.find('.card-actions a.fa-caret-down').trigger('click');
                        } else if (state == 'removed') {
                            panel.find('.card-actions a.fa-times').trigger('click');
                        }
                        panel.data('portlet-state-loaded', true);
                    }
                });
            }

            return this;
        },

        build: function() {
            var _self = this;

            if ( $.isFunction( $.fn.sortable ) ) {
                this.$el.sortable( this.options ).disableSelection();
                this.$el.find('[data-portlet-item]').each(function() {
                    _self.events( $(this) );
                });
            }

            var portlet = this.$el;
            portlet.css('min-height', 150);

            return this;
        },

        events: function($el) {
            var _self = this,
                portlet = $el.closest('[data-plugin-portlet]');

            this.loadState();

            $el.find('.card-actions').on( 'click', 'a.fa-caret-up, a.fa-caret-down, a.fa-times', function( e ) {
                setTimeout(function() {
                    _self.saveState( $el );
                }, 250);
            });

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginPortlet: PluginPortlet
    });

    // jquery plugin
    $.fn.themePluginPortlet = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginPortlet($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);

// Scroll to Top
(function(theme, $) {

    theme = theme || {};

    $.extend(theme, {

        PluginScrollToTop: {

            defaults: {
                wrapper: $('body'),
                offset: 150,
                buttonClass: 'scroll-to-top',
                iconClass: 'fas fa-chevron-up',
                delay: 500,
                visibleMobile: false,
                label: false
            },

            initialize: function(opts) {
                this.initialized = true;

                this
                    .setOptions(opts)
                    .build()
                    .events();

                return this;
            },

            setOptions: function(opts) {
                this.options = $.extend(true, {}, this.defaults, opts);

                return this;
            },

            build: function() {
                var self = this,
                    $el;

                // Base HTML Markup
                $el = $('<a />')
                    .addClass(self.options.buttonClass)
                    .attr({
                        'href': '#',
                    })
                    .append(
                        $('<i />')
                            .addClass(self.options.iconClass)
                    );

                // Visible Mobile
                if (!self.options.visibleMobile) {
                    $el.addClass('hidden-mobile');
                }

                // Label
                if (self.options.label) {
                    $el.append(
                        $('<span />').html(self.options.label)
                    );
                }

                this.options.wrapper.append($el);

                this.$el = $el;

                return this;
            },

            events: function() {
                var self = this,
                    _isScrolling = false;

                // Click Element Action
                self.$el.on('click', function(e) {
                    e.preventDefault();
                    $('body, html').animate({
                        scrollTop: 0
                    }, self.options.delay);
                    return false;
                });

                // Show/Hide Button on Window Scroll event (rAF-throttled to reduce forced reflow).
                (function(){
                    var ticking = false;
                    function onScrollUpdate(){
                        ticking = false;
                        var sc = (window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0);
                        if (sc > self.options.offset) {
                            self.$el.addClass('visible');
                        } else {
                            self.$el.removeClass('visible');
                        }
                    }
                    $(window).on('scroll', function(){
                        if (!ticking) {
                            ticking = true;
                            window.requestAnimationFrame(onScrollUpdate);
                        }
                    });
                })();

                return this;
            }

        }

    });

}).apply(this, [window.theme, jQuery]);



// Spinner
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__spinner';

    var PluginSpinner = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginSpinner.defaults = {
    };

    PluginSpinner.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend( true, {}, PluginSpinner.defaults, opts );

            return this;
        },

        build: function() {
            this.$el.spinner( this.options );

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginSpinner: PluginSpinner
    });

    // jquery plugin
    $.fn.themePluginSpinner = function(opts) {
        return this.each(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginSpinner($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);



// Toggle
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__toggle';

    var PluginToggle = function($el, opts) {
        return this.initialize($el, opts);
    };

    PluginToggle.defaults = {
        duration: 350,
        isAccordion: false,
        addIcons: true
    };

    PluginToggle.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, PluginToggle.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        build: function() {
            var self = this,
                $wrapper = this.options.wrapper,
                $items = $wrapper.find('.toggle'),
                $el = null;

            $items.each(function() {
                $el = $(this);

                if(self.options.addIcons) {
                    $el.find('> label').prepend(
                        $('<i />').addClass('fas fa-plus'),
                        $('<i />').addClass('fas fa-minus')
                    );
                }

                if($el.hasClass('active')) {
                    $el.find('> p').addClass('preview-active');
                    $el.find('> .toggle-content').slideDown(self.options.duration);
                }

                self.events($el);
            });

            if(self.options.isAccordion) {
                self.options.duration = self.options.duration/2;
            }

            return this;
        },

        events: function($el) {
            var self = this,
                previewParCurrentHeight = 0,
                previewParAnimateHeight = 0,
                toggleContent = null;

            $el.find('> label').click(function(e) {

                var $this = $(this),
                    parentSection = $this.parent(),
                    parentWrapper = $this.parents('.toggle'),
                    previewPar = null,
                    closeElement = null;

                if(self.options.isAccordion && typeof(e.originalEvent) != 'undefined') {
                    closeElement = parentWrapper.find('.toggle.active > label');

                    if(closeElement[0] == $this[0]) {
                        return;
                    }
                }

                parentSection.toggleClass('active');

                // Preview Paragraph
                if(parentSection.find('> p').get(0)) {

                    previewPar = parentSection.find('> p');
                    previewParCurrentHeight = previewPar.css('height');
                    previewPar.css('height', 'auto');
                    previewParAnimateHeight = previewPar.css('height');
                    previewPar.css('height', previewParCurrentHeight);

                }

                // Content
                toggleContent = parentSection.find('> .toggle-content');

                if(parentSection.hasClass('active')) {

                    $(previewPar).animate({
                        height: previewParAnimateHeight
                    }, self.options.duration, function() {
                        $(this).addClass('preview-active');
                    });

                    toggleContent.slideDown(self.options.duration, function() {
                        if(closeElement) {
                            closeElement.trigger('click');
                        }
                    });

                } else {

                    $(previewPar).animate({
                        height: 0
                    }, self.options.duration, function() {
                        $(this).removeClass('preview-active');
                    });

                    toggleContent.slideUp(self.options.duration);

                }

            });
        }
    };

    // expose to scope
    $.extend(theme, {
        PluginToggle: PluginToggle
    });

    // jquery plugin
    $.fn.themePluginToggle = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new PluginToggle($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);

// Widget - Todo
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__widgetTodoList';

    var WidgetTodoList = function($el, opts) {
        return this.initialize($el, opts);
    };

    WidgetTodoList.defaults = {
    };

    WidgetTodoList.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build()
                .events();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend( true, {}, WidgetTodoList.defaults, opts );

            return this;
        },

        check: function( input, label ) {
            if ( input.is(':checked') ) {
                label.addClass('line-through');
            } else {
                label.removeClass('line-through');
            }
        },

        build: function() {
            var _self = this,
                $check = this.$el.find('.todo-check');

            $check.each(function () {
                var label = $(this).closest('li').find('.todo-label');
                _self.check( $(this), label );
            });

            return this;
        },

        events: function() {
            var _self = this,
                $remove = this.$el.find( '.todo-remove' ),
                $check = this.$el.find('.todo-check'),
                $window = $( window );

            $remove.on('click.widget-todo-list', function( ev ) {
                ev.preventDefault();
                $(this).closest("li").remove();
            });

            $check.on('change', function () {
                var label = $(this).closest('li').find('.todo-label');
                _self.check( $(this), label );
            });

            if ( $.isFunction( $.fn.sortable ) ) {
                this.$el.sortable({
                    sort: function(event, ui) {
                        var top = event.pageY - _self.$el.offset().top - (ui.helper.outerHeight(true) / 2);
                        ui.helper.css({'top' : top + 'px'});
                    }
                });
            }

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        WidgetTodoList: WidgetTodoList
    });

    // jquery plugin
    $.fn.themePluginWidgetTodoList = function(opts) {
        return this.each(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new WidgetTodoList($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);

// Widget - Toggle
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__widgetToggleExpand';

    var WidgetToggleExpand = function($el, opts) {
        return this.initialize($el, opts);
    };

    WidgetToggleExpand.defaults = {
    };

    WidgetToggleExpand.prototype = {
        initialize: function($el, opts) {
            if ( $el.data( instanceName ) ) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build()
                .events();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend( true, {}, WidgetToggleExpand.defaults, opts );

            return this;
        },

        build: function() {
            return this;
        },

        events: function() {
            var _self = this,
                $toggler = this.$el.find( '.widget-toggle' );

            $toggler.on('click.widget-toggler', function() {
                _self.$el.hasClass('widget-collapsed') ? _self.expand( _self.$el ) : _self.collapse( _self.$el );
            });

            return this;
        },

        expand: function( content ) {
            content.children( '.widget-content-expanded' ).slideDown( 'fast', function() {
                $(this).css( 'display', '' );
                content.removeClass( 'widget-collapsed' );
            });
        },

        collapse: function( content ) {
            content.children('.widget-content-expanded' ).slideUp( 'fast', function() {
                content.addClass( 'widget-collapsed' );
                $(this).css( 'display', '' );
            });
        }
    };

    // expose to scope
    $.extend(theme, {
        WidgetToggleExpand: WidgetToggleExpand
    });

    // jquery plugin
    $.fn.themePluginWidgetToggleExpand = function(opts) {
        return this.each(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new WidgetToggleExpand($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);



(function($) {

    'use strict';

    // Navigation
    var $items = $( '.nav-main li.nav-parent' );

    function expand( $li ) {
        $li.children( 'ul.nav-children' ).slideDown( 'fast', function() {
            $li.addClass( 'nav-expanded' );
            $(this).css( 'display', '' );
            ensureVisible( $li );
        });
    }

    function collapse( $li ) {
        $li.children('ul.nav-children' ).slideUp( 'fast', function() {
            $(this).css( 'display', '' );
            $li.removeClass( 'nav-expanded' );
        });
    }

    function ensureVisible( $li ) {
        var scroller = $li.offsetParent();
        if ( !scroller.get(0) ) {
            return false;
        }

        var top = $li.position().top;
        if ( top < 0 ) {
            scroller.animate({
                scrollTop: scroller.scrollTop() + top
            }, 'fast');
        }
    }

    function buildSidebarNav( anchor, prev, next, ev ) {
        // Avoid expensive layout reads (getComputedStyle/offsetWidth) on each click.
        // Use a configurable arrow width via data attribute, fallback to a small constant.
        if (anchor.prop('href')) {
            var arrowWidth = parseInt(anchor.attr('data-arrow-width'), 10);
            if (isNaN(arrowWidth)) { arrowWidth = 24; }
            var el = anchor.get(0);
            if (el && typeof ev.offsetX === 'number') {
                // Only prevent navigation if clicking inside the right-most arrow area
                var width = el.clientWidth || 0;
                if (width && ev.offsetX > width - arrowWidth) {
                    ev.preventDefault();
                }
            }
        }

        if ( prev.get( 0 ) !== next.get( 0 ) ) {
            collapse( prev );
            expand( next );
        } else {
            collapse( prev );
        }
    }

    $items.find('> a').on('click', function( ev ) {

        var $html   = $('html'),
            $window = $(window),
            $anchor = $( this ),
            $prev   = $anchor.closest('ul.nav').find('> li.nav-expanded' ),
            $next   = $anchor.closest('li'),
            $ev     = ev;

        if( $anchor.attr('href') == '#' ) {
            ev.preventDefault();
        }

        if( !$html.hasClass('sidebar-left-big-icons') ) {
            buildSidebarNav( $anchor, $prev, $next, $ev );
        } else if( $html.hasClass('sidebar-left-big-icons') && $window.width() < 768 ) {
            buildSidebarNav( $anchor, $prev, $next, $ev );
        }

    });

    $('.nav-main').on('touchend', function(e){
        var $target = $( e.target );

        if( $target.closest('li').hasClass( 'nav-parent' ) ) {
            setTimeout(function(){
                $('html').removeClass('sidebar-left-collapsed');
                $('.content-body').trigger('click');
            }, 100);
        } else {
            if( $target.closest('a').attr('href') ) {
                window.location.href = $target.closest('a').attr('href');
            }
        }
    });

    // Chrome Fix
    $.browser.chrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
    if( $.browser.chrome && !$.browser.mobile ) {
        var flag = true;
        $('.sidebar-left .nav-main li a').on('click', function(){
            flag = false;
            setTimeout(function(){
                flag = true;
            }, 200);
        });

        $('.nano').on('mouseenter', function(e){
            $(this).addClass('hovered');
        });

        $('.nano').on('mouseleave', function(e){
            if( flag ) {
                $(this).removeClass('hovered');
            }
        });
    }

    // Do not force non-link anchors to use href="#"; this harms crawlability.
    // Instead, mark them as interactive controls for accessibility without making them links.
    $('.nav-main a').filter(':not([href])').attr('role', 'button').attr('tabindex', '0');

    // Treat UI-only anchors as buttons to avoid being flagged as non-crawlable links
    $('a.accordion-toggle').filter(':not([href])').attr('role','button').attr('tabindex','0');
    $('a[data-bs-toggle="collapse"]').filter(':not([href])').attr('role','button').attr('tabindex','0');
    $('a.sidebar-right-toggle, a[data-open="sidebar-right"]').filter(':not([href])').attr('role','button').attr('tabindex','0');

    // Layout Fixed + Modern - Page Header Bottom Border
    if( $('html').hasClass('fixed') && $('html').hasClass('modern') && $('.page-header.page-header-left-inline-breadcrumb').get(0) ) {
        var $win = $(window);
        var $hdr = $('.page-header.page-header-left-inline-breadcrumb');
        var ticking = false;
        var lastY = window.scrollY || $win.scrollTop();
        var applied = false;
        function onScrollUpdate() {
            var y = lastY;
            var shouldAdd = y > 5;
            if (shouldAdd !== applied) {
                $hdr.toggleClass('border border-top-0 border-right-0 border-left-0 border-color-light-grey-2', shouldAdd);
                applied = shouldAdd;
            }
            ticking = false;
        }
        $win.on('scroll', function(){
            lastY = window.scrollY || $win.scrollTop();
            if (!ticking) {
                window.requestAnimationFrame(onScrollUpdate);
                ticking = true;
            }
        });
        // Initialize once
        onScrollUpdate();
    }

    // Data Hash
    $('[data-hash]').each(function() {

        var target = $(this).attr('href'),
            offset = ($(this).is("[data-hash-offset]") ? $(this).data('hash-offset') : 0);

        if($(target).get(0)) {
            $(this).on('click', function(e) {
                e.preventDefault();

                if( !$(e.target).is('i') ) {

                    // Close Collapse if open
                    $(this).parents('.collapse.show').collapse('hide');

                    $window.trigger('resize');

                    scrollToTarget(target, offset);

                }

            });
        }

    });

    // Scroll To Target
    function scrollToTarget(target, offset) {
        $('body').addClass('scrolling');

        $('html, body').animate({
            scrollTop: $(target).offset().top - offset
        }, 600, function() {
            $('body').removeClass('scrolling');
        });
    }

    // Mobile Nav
    if($.browser.mobile) {
        var moving = false;

        $('#menu').on('touchmove', function (e) {
            moving = true;
        });

        $('#menu').on('touchend', function (e) {
            setTimeout(function () {
                moving = false;
            }, 300);
        });

        $('#menu .nav-link').each(function () {
            // Keep href attribute for crawlability; do not move it to data-link.
        }).on('click', function (e) {
            // If the user is in a touch scroll gesture, prevent accidental activation.
            if (moving) {
                e.preventDefault();
            }
        });
    }

}).apply(this, [jQuery]);

// Skeleton
(function(theme, $) {

    'use strict';

    theme = theme || {};

    var $body				= $( 'body' ),
        $html				= $( 'html' ),
        $window				= $( window ),
        isAndroid			= navigator.userAgent.toLowerCase().indexOf('android') > -1,
        isIpad      		= navigator.userAgent.match(/iPad/i) != null,
        updatingNanoScroll  = false;

    // mobile devices with fixed has a lot of issues when focus inputs and others...
    if ( typeof $.browser !== 'undefined' && $.browser.mobile && $html.hasClass('fixed') ) {
        $html.removeClass( 'fixed' ).addClass( 'scroll' );
    }

    var Skeleton = {

        options: {
            sidebars: {
                menu: '#content-menu',
                left: '#sidebar-left',
                right: '#sidebar-right'
            }
        },

        //customScroll: ( !Modernizr.overflowscrolling && !isAndroid && $.fn.nanoScroller !== 'undefined'),
        customScroll: ( !Modernizr.overflowscrolling && !isAndroid && typeof $.fn.nanoScroller === 'function'),


        initialize: function() {
            this
                .setVars()
                .build()
                .events();
        },

        setVars: function() {
            this.sidebars = {};

            this.sidebars.left = {
                $el: $( this.options.sidebars.left )
            };

            this.sidebars.right = {
                $el: $( this.options.sidebars.right ),
                isOpened: $html.hasClass( 'sidebar-right-opened' )
            };

            this.sidebars.menu = {
                $el: $( this.options.sidebars.menu ),
                isOpened: $html.hasClass( 'inner-menu-opened' )
            };

            return this;
        },

        build: function() {

            if ( typeof $.browser !== 'undefined' && $.browser.mobile ) {
                $html.addClass( 'mobile-device' );
            } else {
                $html.addClass( 'no-mobile-device' );
            }

            $html.addClass( 'custom-scroll' );
            if ( this.customScroll ) {
                this.buildSidebarLeft();
                this.buildContentMenu();
            }

            if( isIpad ) {
                this.fixIpad();
            }

            this.buildSidebarRight();

            return this;
        },

        events: function() {
            if ( this.customScroll ) {
                this.eventsSidebarLeft();
            }

            this.eventsSidebarRight();
            this.eventsContentMenu();

            if ( typeof $.browser !== 'undefined' && !this.customScroll && isAndroid ) {
                this.fixScroll();
            }

            return this;
        },

        fixScroll: function() {
            var _self = this;

            $window
                .on( 'sidebar-left-opened sidebar-right-toggle', function( e, data ) {
                    _self.preventBodyScrollToggle( data.added );
                });

        },

        fixIpad: function() {
            var _self = this;

            $('.header, .page-header, .content-body').on('click', function(){
                $html.removeClass('sidebar-left-opened');
            });
        },

        buildSidebarLeft: function() {

            var initialPosition = 0;

            this.sidebars.left.isOpened = !$html.hasClass( 'sidebar-left-collapsed' ) || $html.hasClass( 'sidebar-left-opened' );

            this.sidebars.left.$nano = this.sidebars.left.$el.find( '.nano' );

            if (typeof localStorage !== 'undefined') {
                this.sidebars.left.$nano.on('update', function(e, values) {
                    localStorage.setItem('sidebar-left-position', values.position);
                });

                if (localStorage.getItem('sidebar-left-position') !== null) {
                    initialPosition = localStorage.getItem('sidebar-left-position');
                    this.sidebars.left.$el.find( '.nano-content').scrollTop(initialPosition);
                }
            }

            if (typeof this.sidebars.left.$nano.nanoScroller === 'function') {
                this.sidebars.left.$nano.nanoScroller({
                    scrollTop: initialPosition,
                    alwaysVisible: true,
                    preventPageScrolling: $html.hasClass('fixed')
                });
            } else {
                console.error('nanoScroller is not a function. Ensure that nanoScroller is imported and initialized correctly.');
            }

            return this;
        },

        eventsSidebarLeft: function() {

            var _self = this,
                $nano = this.sidebars.left.$nano;

            var open = function() {
                if ( _self.sidebars.left.isOpened ) {
                    return close();
                }

                _self.sidebars.left.isOpened = true;

                $html.addClass( 'sidebar-left-opened' );

                $window.trigger( 'sidebar-left-toggle', {
                    added: true,
                    removed: false
                });

                $html.on( 'click.close-left-sidebar', function(e) {
                    e.stopPropagation();
                    close(e);
                });


            };

            var close = function(e) {
                if ( !!e && !!e.target && ($(e.target).closest( '.sidebar-left' ).get(0) || !$(e.target).closest( 'html' ).get(0)) ) {
                    e.preventDefault();
                    return false;
                } else {

                    $html.removeClass( 'sidebar-left-opened' );
                    $html.off( 'click.close-left-sidebar' );

                    $window.trigger( 'sidebar-left-toggle', {
                        added: false,
                        removed: true
                    });

                    _self.sidebars.left.isOpened = !$html.hasClass( 'sidebar-left-collapsed' );

                }
            };

            var updateNanoScroll = function() {
                if (updatingNanoScroll) {
                    if ( $.support.transition ) {
                        $nano.nanoScroller();
                        $nano
                            .one('bsTransitionEnd', updateNanoScroll)
                            .emulateTransitionEnd(150)
                    } else {
                        updateNanoScroll();
                    }

                    updatingNanoScroll = true;

                    setTimeout(function() {
                        updatingNanoScroll = false;
                    }, 200);
                }
            };

            var isToggler = function( element ) {
                return $(element).data('fire-event') === 'sidebar-left-toggle' || $(element).parents().data('fire-event') === 'sidebar-left-toggle';
            };

            this.sidebars.left.$el
                .on( 'click', function() {
                    updateNanoScroll();

                    $(window).trigger('resize');
                })
                .on('touchend', function(e) {
                    _self.sidebars.left.isOpened = !$html.hasClass( 'sidebar-left-collapsed' ) || $html.hasClass( 'sidebar-left-opened' );
                    if ( !_self.sidebars.left.isOpened && !isToggler(e.target) ) {
                        e.stopPropagation();
                        e.preventDefault();
                        open();
                    }

                    $(window).trigger('resize');
                });

            $nano
                .on( 'mouseenter', function() {
                    if ( $html.hasClass( 'sidebar-left-collapsed' ) ) {
                        $nano.nanoScroller();
                    }
                })
                .on( 'mouseleave', function() {
                    if ( $html.hasClass( 'sidebar-left-collapsed' ) ) {
                        $nano.nanoScroller();
                    }
                });

            $window.on( 'sidebar-left-toggle', function(e, toggle) {
                if ( toggle.removed ) {
                    $html.removeClass( 'sidebar-left-opened' );
                    $html.off( 'click.close-left-sidebar' );
                }

                // Recalculate Owl Carousel sizes
                $('.owl-carousel').trigger('refresh.owl.carousel');
            });

            return this;
        },

        buildSidebarRight: function() {
            this.sidebars.right.isOpened = $html.hasClass( 'sidebar-right-opened' );

            if ( this.customScroll ) {
                this.sidebars.right.$nano = this.sidebars.right.$el.find( '.nano' );

                this.sidebars.right.$nano.nanoScroller({
                    alwaysVisible: true,
                    preventPageScrolling: true
                });
            }

            return this;
        },

        eventsSidebarRight: function() {
            var _self = this;

            var open = function() {
                if ( _self.sidebars.right.isOpened ) {
                    return close();
                }

                _self.sidebars.right.isOpened = true;

                $html.addClass( 'sidebar-right-opened' );

                $window.trigger( 'sidebar-right-toggle', {
                    added: true,
                    removed: false
                });

                $html.on( 'click.close-right-sidebar', function(e) {
                    if( !$( e.target ).data('toggle') ) {
                        e.stopPropagation();
                    }
                    close(e);
                });
            };

            var close = function(e) {
                if ( !!e && !!e.target && ($(e.target).closest( '.sidebar-right' ).get(0) || !$(e.target).closest( 'html' ).get(0)) ) {
                    return false;
                }

                $html.removeClass( 'sidebar-right-opened' );
                $html.off( 'click.close-right-sidebar' );

                $window.trigger( 'sidebar-right-toggle', {
                    added: false,
                    removed: true
                });

                _self.sidebars.right.isOpened = false;
            };

            var bind = function() {
                $('[data-open="sidebar-right"]').on('click', function(e) {
                    var $el = $(this);
                    e.stopPropagation();

                    if ( $el.is('a') )
                        e.preventDefault();

                    open();
                });
            };

            this.sidebars.right.$el.find( '.mobile-close' )
                .on( 'click', function( e ) {
                    e.preventDefault();
                    $html.trigger( 'click.close-right-sidebar' );
                });

            bind();

            return this;
        },

        buildContentMenu: function() {
            if ( !$html.hasClass( 'fixed' ) ) {
                return false;
            }

            this.sidebars.menu.$nano = this.sidebars.menu.$el.find( '.nano' );

            this.sidebars.menu.$nano.nanoScroller({
                alwaysVisible: true,
                preventPageScrolling: true
            });

            return this;
        },

        eventsContentMenu: function() {
            var _self = this;

            var open = function() {
                if ( _self.sidebars.menu.isOpened ) {
                    return close();
                }

                _self.sidebars.menu.isOpened = true;

                $html.addClass( 'inner-menu-opened' );

                $window.trigger( 'inner-menu-toggle', {
                    added: true,
                    removed: false
                });

                $html.on( 'click.close-inner-menu', function(e) {

                    close(e);
                });

            };

            var close = function(e) {
                var hasEvent,
                    hasTarget,
                    isCollapseButton,
                    isInsideModal,
                    isInsideInnerMenu,
                    isInsideHTML,
                    $target;

                hasEvent = !!e;
                hasTarget = hasEvent && !!e.target;

                if ( hasTarget ) {
                    $target = $(e.target);
                }

                isCollapseButton = hasTarget && !!$target.closest( '.inner-menu-collapse' ).get(0);
                isInsideModal = hasTarget && !!$target.closest( '.mfp-wrap' ).get(0);
                isInsideInnerMenu = hasTarget && !!$target.closest( '.inner-menu' ).get(0);
                isInsideHTML = hasTarget && !!$target.closest( 'html' ).get(0);

                if ( (!isCollapseButton && (isInsideInnerMenu || !isInsideHTML)) || isInsideModal ) {
                    return false;
                }

                e.stopPropagation();

                $html.removeClass( 'inner-menu-opened' );
                $html.off( 'click.close-inner-menu' );

                $window.trigger( 'inner-menu-toggle', {
                    added: false,
                    removed: true
                });

                _self.sidebars.menu.isOpened = false;
            };

            var bind = function() {
                $('[data-open="inner-menu"]').on('click', function(e) {
                    var $el = $(this);
                    e.stopPropagation();

                    if ( $el.is('a') )
                        e.preventDefault();

                    open();
                });
            };

            bind();

            /* Nano Scroll */
            if ( $html.hasClass( 'fixed' ) ) {
                var $nano = this.sidebars.menu.$nano;

                var updateNanoScroll = function() {
                    if ( $.support.transition ) {
                        $nano.nanoScroller();
                        $nano
                            .one('bsTransitionEnd', updateNanoScroll)
                            .emulateTransitionEnd(150)
                    } else {
                        updateNanoScroll();
                    }
                };

                this.sidebars.menu.$el
                    .on( 'click', function() {
                        updateNanoScroll();
                    });
            }

            return this;
        },

        preventBodyScrollToggle: function( shouldPrevent, $el ) {
            setTimeout(function() {
                if ( shouldPrevent ) {
                    $body
                        .data( 'scrollTop', $body.get(0).scrollTop )
                        .css({
                            position: 'fixed',
                            top: $body.get(0).scrollTop * -1
                        })
                } else {
                    $body
                        .css({
                            position: '',
                            top: ''
                        })
                        .scrollTop( $body.data( 'scrollTop' ) );
                }
            }, 150);
        }

    };

    // expose to scope
    $.extend(theme, {
        Skeleton: Skeleton
    });

}).apply(this, [window.theme, jQuery]);

// Tab Navigation
(function($) {

    'use strict';

    if( $('html.has-tab-navigation').get(0) ) {

        var $window 	 	  = $( window ),
            $toggleMenuButton = $('.toggle-menu'),
            $navActive   	  = $('.tab-navigation nav > ul .nav-active'),
            $tabNav      	  = $('.tab-navigation'),
            $tabItem 	 	  = $('.tab-navigation nav > ul > li a'),
            $contentBody 	  = $('.content-body');

        $tabItem.on('click', function(e){
            if( $(this).parent().hasClass('dropdown') || $(this).parent().hasClass('dropdown-submenu') ) {
                if( $window.width() < 992 ) {
                    if( $(this).parent().hasClass('nav-expanded') ) {
                        $(this).closest('li').find( '> ul' ).slideUp( 'fast', function() {
                            $(this).css( 'display', '' );
                            $(this).closest('li').removeClass( 'nav-expanded' );
                        });
                    } else {
                        if( $(this).parent().hasClass('dropdown') ) {
                            $tabItem.parent().removeClass('nav-expanded');
                        }

                        $(this).parent().addClass('expanding');

                        $(this).closest('li').find( '> ul' ).slideDown( 'fast', function() {
                            $tabItem.parent().removeClass('expanding');
                            $(this).closest('li').addClass( 'nav-expanded' );
                            $(this).css( 'display', '' );

                            if( ($(this).position().top + $(this).height()) < $window.scrollTop() ) {
                                $('html,body').animate({ scrollTop: $(this).offset().top - 100 }, 300);
                            }
                        });
                    }
                } else {
                    if( !$(this).parent().hasClass('dropdown') ) {
                        e.preventDefault();
                        return false;
                    }

                    if( $(this).parent().hasClass('nav-expanded') ) {
                        $tabItem.parent().removeClass('nav-expanded');
                        $contentBody.removeClass('tab-menu-opened');
                        return;
                    }

                    $tabItem.parent().removeClass('nav-expanded');
                    $contentBody.addClass('tab-menu-opened');
                    $(this).parent().addClass('nav-expanded');
                }
            }
        });

        // Optimize scroll handler to avoid forced reflow/layout thrash by throttling with rAF
        // and minimizing layout reads per frame.
        (function(){
            var rafScheduled = false;
            function onScrollRaf(){
                rafScheduled = false;
                if (window.innerWidth < 992) {
                    var el = $tabNav.get(0);
                    if (!el) return;
                    var rect = el.getBoundingClientRect();
                    // Compute absolute bottom position of the tab navigation
                    var tabNavOffset = rect.top + (window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0) + rect.height + 100;
                    var windowOffset = (window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0);
                    if (windowOffset > tabNavOffset) {
                        $tabNav.removeClass('show');
                    }
                }
            }
            $window.on('scroll', function(){
                if (!rafScheduled) {
                    rafScheduled = true;
                    window.requestAnimationFrame(onScrollRaf);
                }
            });
        })();

        $toggleMenuButton.on('click', function(){
            if( !$tabNav.hasClass('show') ) {
                $('html,body').animate({ scrollTop: $tabNav.offset().top - 50 }, 300);
            }
        });

    }

}).apply(this, [jQuery]);


// Carousel
(function($) {

    'use strict';

    if ( $.isFunction($.fn[ 'owlCarousel' ]) ) {

        $(function() {
            $('[data-plugin-carousel]').each(function() {
                var $this = $( this ),
                    opts = {};

                var pluginOptions = $this.data('plugin-options');
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginCarousel(opts);
            });
        });

    }

}).apply(this, [jQuery]);


// Header Menu Nav
(function(theme, $) {

    'use strict';

    if (typeof theme.Nav !== 'undefined') {
        theme.Nav.initialize();
    }

}).apply(this, [window.theme, jQuery]);

// iosSwitcher
(function($) {

    'use strict';

    if ( typeof Switch !== 'undefined' && $.isFunction( Switch ) ) {

        $(function() {
            $('[data-plugin-ios-switch]').each(function() {
                var $this = $( this );

                $this.themePluginIOS7Switch();
            });
        });

    }

}).apply(this, [jQuery]);

// Lazy Load
(function($) {

    'use strict';

    if ($.isFunction($.fn['themePluginLazyLoad'])) {

        $(function() {
            $('[data-plugin-lazyload]:not(.manual)').each(function() {
                var $this = $(this),
                    opts;

                var pluginOptions = theme.fn.getOptions($this.data('plugin-options'));
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginLazyLoad(opts);
            });
        });

    }

}).apply(this, [jQuery]);

// Lightbox (dynamically loads Magnific Popup when needed)
(function($) {

    'use strict';

    $(function() {
        var $targets = $('[data-plugin-lightbox], .lightbox:not(.manual)');
        if ($targets.length) {
            if (typeof window.loadMagnificPopup === 'function') {
                window.loadMagnificPopup().then(function(){
                    $targets.each(function() {
                        var $this = $( this ),
                            opts = {};
                        var pluginOptions = $this.data('plugin-options');
                        if (pluginOptions)
                            opts = pluginOptions;
                        $this.themePluginLightbox(opts);
                    });
                });
            } else if ($.fn && $.fn.magnificPopup) {
                $targets.each(function() {
                    var $this = $( this ),
                        opts = {};
                    var pluginOptions = $this.data('plugin-options');
                    if (pluginOptions)
                        opts = pluginOptions;
                    $this.themePluginLightbox(opts);
                });
            }
        }
    });

}).apply(this, [jQuery]);





// Portlets
(function($) {

    'use strict';

    $(function() {
        $('[data-plugin-portlet]').each(function() {
            var $this = $( this ),
                opts = {};

            var pluginOptions = $this.data('plugin-options');
            if (pluginOptions)
                opts = pluginOptions;

            $this.themePluginPortlet(opts);
        });
    });

}).apply(this, [jQuery]);

// Scroll to Top
(function(theme, $) {
    // Scroll to Top Button.
    if (typeof theme.PluginScrollToTop !== 'undefined') {
        theme.PluginScrollToTop.initialize();
    }
}).apply(this, [window.theme, jQuery]);


// Sidebar Widgets
(function($) {

    'use strict';

    function expand( content ) {
        content.children( '.widget-content' ).slideDown( 'fast', function() {
            $(this).css( 'display', '' );
            content.removeClass( 'widget-collapsed' );
        });
    }

    function collapse( content ) {
        content.children('.widget-content' ).slideUp( 'fast', function() {
            content.addClass( 'widget-collapsed' );
            $(this).css( 'display', '' );
        });
    }

    var $widgets = $( '.sidebar-widget' );

    $widgets.each( function() {

        var $widget = $( this ),
            $toggler = $widget.find( '.widget-toggle' );

        $toggler.on('click.widget-toggler', function() {
            $widget.hasClass('widget-collapsed') ? expand($widget) : collapse($widget);
        });
    });

}).apply(this, [jQuery]);

// Spinner
(function($) {

    'use strict';

    if ( $.isFunction($.fn[ 'spinner' ]) ) {

        $(function() {
            $('[data-plugin-spinner]').each(function() {
                var $this = $( this ),
                    opts = {};

                var pluginOptions = $this.data('plugin-options');
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginSpinner(opts);
            });
        });

    }

}).apply(this, [jQuery]);


// Toggle
(function($) {

    'use strict';

    $(function() {
        $('[data-plugin-toggle]').each(function() {
            var $this = $( this ),
                opts = {};

            var pluginOptions = $this.data('plugin-options');
            if (pluginOptions)
                opts = pluginOptions;

            $this.themePluginToggle(opts);
        });
    });

}).apply(this, [jQuery]);

// Tooltip
(function($) {

    'use strict';

    if ( $.isFunction( $.fn['tooltip'] ) ) {
        $( '[data-toggle=tooltip],[rel=tooltip]' ).tooltip({ container: 'body' });
    }

}).apply(this, [jQuery]);

// Widget - Todo
(function($) {

    'use strict';

    if ( $.isFunction($.fn[ 'themePluginWidgetTodoList' ]) ) {

        $(function() {
            $('[data-plugin-todo-list], ul.widget-todo-list').each(function() {
                var $this = $( this ),
                    opts = {};

                var pluginOptions = $this.data('plugin-options');
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginWidgetTodoList(opts);
            });
        });

    }

}).apply(this, [jQuery]);

// Widget - Toggle
(function($) {

    'use strict';

    if ( $.isFunction($.fn[ 'themePluginWidgetToggleExpand' ]) ) {

        $(function() {
            $('[data-plugin-toggle-expand], .widget-toggle-expand').each(function() {
                var $this = $( this ),
                    opts = {};

                var pluginOptions = $this.data('plugin-options');
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginWidgetToggleExpand(opts);
            });
        });
    }

}).apply(this, [jQuery]);


// Base
(function(theme, $) {

    'use strict';

    theme = theme || {};

    theme.Skeleton.initialize();

}).apply(this, [window.theme, jQuery]);


